import React from "react";

const MaintenancePlans = () => {
  return (
    <div className="mt-16 max-w-5xl mx-auto px-6 lg:px-8">
    <div className="mt-16 bg-surface border border-border/50 rounded-xl p-6 brand-shadow">
      <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
        <span className="w-1.5 h-6 bg-primary rounded-full"></span>
        Maintenance & Support Plans
      </h2>

      <div className="mt-6 space-y-4">
        <div className="flex justify-between items-center border-b border-border/30 pb-3">
          <span className="font-semibold text-foreground">
            Basic Maintenance (Bug Fixes)
          </span>
          <span className="font-bold text-foreground">₹8K / month per Platform</span>
        </div>

        <div className="flex justify-between items-center border-b border-border/30 pb-3">
          <span className="font-semibold text-foreground">
            Standard Maintenance (Bug Fix + OS Updates)
          </span>
          <span className="font-bold text-foreground">₹10K / month per Platform</span>
        </div>

        <div className="flex justify-between items-center border-b border-border/30 pb-3">
          <span className="font-semibold text-foreground">
            Premium Maintenance (Priority Support)
          </span>
          <span className="font-bold text-foreground">₹20K / month per platform</span>
        </div>
      </div>

      <ul className="mt-4 text-sm text-muted-foreground space-y-2 list-disc pl-5">
        <li>Maintenance is optional but recommended after project delivery and post launch</li>
        <li>New features / modification or major changes are not included in maintenance and will charge separately</li>
        <li>Third-party service costs are not part of maintenance plans.</li>
        <li>Emergency fixes outside scope may be charged separately.</li>
      </ul>
    </div></div>
  );
};

export default MaintenancePlans;
